import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { RecordAccessPage } from '~/features/access/record-access-page';

/**
 * Who can use one record (web-redesign-03 phase 6; the Records canvas, "Decide
 * who can use a record"). `?person=` opens one person in the right panel,
 * including somebody picked from Give someone access who is not in it yet.
 */
const search = z.object({ person: z.string().optional() });

function AccessRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { person } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RecordAccessPage
      recordId={recordId}
      openId={person ?? null}
      onOpen={(userId) => void navigate({ search: userId === null ? {} : { person: userId } })}
    />
  );
}

export const Route = createFileRoute('/_app/records/$recordId/access')({ validateSearch: search, component: AccessRoute });
